import isConsentResolved from './isConsentResolved'

export default isConsentResolved
